import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.events = this.el.querySelectorAll('.js-event');
        this.button = this.el.querySelector('.js-button');

        if (this.events.length) {
            for (let i = 9; i < this.events.length; i++) {
                this.events[i].classList.add('is-hidden');
            }

            this.button.addEventListener('click', () => this.loadMore());

            if (this.events.length <= 9) {
                this.button.classList.add('is-hidden');
            }
        }
    }

    loadMore() {
        let count = 0; // Track how many elements have been shown
    
        for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].classList.contains('is-hidden')) {
                this.events[i].classList.remove('is-hidden');
                count++;
    
                if (count === 9) {
                    break; // Stop once 6 elements are revealed
                }
            }
        }
    
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 10);
    
        if (!this.el.querySelector('.is-hidden')) {
            this.button.classList.add('is-hidden');
        }
    }
    
}
